<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useTimesheets } from '../store/timesheets'
import { storeToRefs } from 'pinia'

const { hasDenied } = storeToRefs(useTimesheets())

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`timecard.${key}`)
</script>
<template>
  <q-banner v-if="hasDenied" class="text-white bg-negative q-mb-md">
    <p>{{ label('denied') }}</p>
  </q-banner>
</template>
